import React, { FormEvent } from 'react';
import {
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import { Location } from '../../../../types/api/Location';
import { useFormikContext } from 'formik';
import cx from 'classnames';
import { PlantChoiceFormValues } from './PlantChoice';
import {
  WithTranslation,
  withTranslation,
} from 'react-i18next';

const LocationDropdown = (props: {
  onChange: (e: FormEvent<FormControl>) => void,
  locations: Location[],
} & WithTranslation) => {
  const {
    values,
    touched,
    errors,
  } = useFormikContext<PlantChoiceFormValues>();
  return (
    <FormGroup className={cx({'has-error': errors.locationId && touched.locationId})}>
      <ControlLabel>{props.t('Location')}</ControlLabel>
      <FormControl
        componentClass="select"
        id="location-select"
        name="locationId"
        value={values.locationId || ''}
        onChange={props.onChange}
        bsSize="sm"
      >
        <option/>
        {props.locations.map(location => (
          <option
            key={location.id}
            value={location.id}
            title={`#${location.id}`}
          >
            {location.name || location.shortName}
          </option>
        ))}
      </FormControl>
    </FormGroup>
  );
};

export default withTranslation()(LocationDropdown);
